// extracted by mini-css-extract-plugin
export default {"wrap":"BarChart_wrap__l-fxl","svg":"BarChart_svg__6mwCf","barWrap":"BarChart_barWrap__rwaIl","barAcc":"BarChart_barAcc__UGCpg","context-item":"BarChart_context-item__mQcLB"};